module.exports = __webpack_public_path__ + "img/indipendentday-contest-logo.9f8f0b3d.png";